<psei-button
  *pseiLet="(selectedLanguage$ | async) as selectedLanguage"
  [tile]="true"
  [color]="'secondary'"
  [label]="selectedLanguage?.toUpperCase()"
  icon="globe"
  [open]="langIsActive"
  [variant]="'dropdown'"
  [chevron]="true"
>
  <ng-template #dropdownRef>
    <psei-select-list
      id="lang-select"
      [output]="'value'"
      [selected]="selectedLanguage"
      [items]="langItems"
      [searchbar]="false"
      [singleSelect]="true"
      [selectedFirst]="true"
      [allowUnselect]="false"
      [virtualScroll]="false"
      [listHeight]="85"
      (closeDropdown)="langIsActive = false"
      (selectedChange)="handleLangChange($event)">
    </psei-select-list>
  </ng-template>
</psei-button>
